module.exports = __webpack_public_path__ + "img/portomagno.15bf1399.jpg";